import React from 'react';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking';
import S from '../../../../commons/components/style/HowSafeDealWorksModal';
import { USER_TYPE } from '../../constants';
import { BuyerModalBody, SellerModalBody } from './ModalBody';
import { TermsAndConditionsLink } from './TermsAndConditionsLink';
import { useI18n } from '../../../../i18n';
import trackingKeys from '../../../../commons/constants/trackingKeys';

const { howSafeDealWorkModalShown } = trackingKeys.events.safeDeal;
const { deliverySales } = trackingKeys.touchPointPage;

interface ModalProps {
  closeModal: () => void;
  userType: USER_TYPE;
  trackingExtras: Record<string, any>;
}

const DesktopModal = ({ closeModal, userType, trackingExtras }: ModalProps) => {
  const i18n = useI18n();

  return (
    <S.ModalWrapper
      position="center"
      data-testid="how-sd-works-modal-desktop"
      data-cy="how-sd-works-modal-desktop"
      showCloseIcon
      onClose={closeModal}
      maskClosable
      closableOnEscPress
    >
      <S.ModalContent>
        <S.ModalDesktopHeadline>{i18n`dlv_safedeal_info_modal_title`}</S.ModalDesktopHeadline>
        {userType === USER_TYPE.BUYER && <BuyerModalBody />}
        {userType === USER_TYPE.SELLER && <SellerModalBody />}
        <TermsAndConditionsLink trackingExtras={trackingExtras} userType={userType} />
      </S.ModalContent>
    </S.ModalWrapper>
  );
};

const MobileModal = ({ closeModal, userType, trackingExtras }: ModalProps) => {
  const i18n = useI18n();

  return (
    <S.SheetBottomModal
      closeButtonText={i18n`dlv_safedeal_info_close`}
      isVisible
      onClose={closeModal}
      data-testid="how-sd-works-modal-mobile"
      data-cy="how-sd-works-modal-mobile"
    >
      <S.ModalContent>
        <S.ModalMobileHeadline>{i18n`dlv_safedeal_info_modal_title`}</S.ModalMobileHeadline>
        {userType === USER_TYPE.BUYER && <BuyerModalBody />}
        {userType === USER_TYPE.SELLER && <SellerModalBody />}
        <TermsAndConditionsLink trackingExtras={trackingExtras} userType={userType} />
      </S.ModalContent>
    </S.SheetBottomModal>
  );
};

interface Props {
  isDesktop: boolean;
  closeModal: () => void;
  userType: USER_TYPE;
  trackingExtras: Record<string, any>;
}

// Note: How Safety Package Works Modal
export const HowSafeDealWorksModal = ({
  isDesktop,
  closeModal,
  userType,
  trackingExtras,
}: Props) => {
  const trackEvent = useTrackEvent();

  React.useEffect(() => {
    trackEvent(howSafeDealWorkModalShown, null, null, {
      ...trackingExtras,
      touch_point_page: deliverySales,
    });
  }, []);

  return isDesktop ? (
    <DesktopModal closeModal={closeModal} userType={userType} trackingExtras={trackingExtras} />
  ) : (
    <MobileModal closeModal={closeModal} userType={userType} trackingExtras={trackingExtras} />
  );
};
